// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Control } from "./control";

export class NormalControl implements flatbuffers.IUnpackableObject<NormalControlT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalControl {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalControl(bb: flatbuffers.ByteBuffer, obj?: NormalControl): NormalControl {
    return (obj || new NormalControl()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNormalControl(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalControl,
  ): NormalControl {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalControl()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  message(): Control {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : Control.CarCallLock;
  }

  static startNormalControl(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: Control) {
    builder.addFieldInt16(0, message, Control.CarCallLock);
  }

  static endNormalControl(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalControl(builder: flatbuffers.Builder, message: Control): flatbuffers.Offset {
    NormalControl.startNormalControl(builder);
    NormalControl.addMessage(builder, message);
    return NormalControl.endNormalControl(builder);
  }

  unpack(): NormalControlT {
    return new NormalControlT(this.message());
  }

  unpackTo(_o: NormalControlT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalControlT {
    const t = new NormalControlT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalControlT implements flatbuffers.IGeneratedObject {
  constructor(public message: Control = Control.CarCallLock) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalControl.createNormalControl(builder, this.message);
  }

  clone(): NormalControlT {
    const obj = new NormalControlT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalControlT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalControl(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
